import styles from "./Main.module.css";
function Main({ user, stats = {} }) {
  if (!user) return <p>Загрузка данных пользователя...</p>;

  // дефолтные значения для stats
  const {
    activeCompanies = 0,
    inactiveCompanies = 0,
    withCashIntegration = 0,
    withoutCashIntegration = 0,
    totalSales = 0,
    kaspiIntegration = 0
  } = stats;

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>
        Добро пожаловать, {user.name} {user.surname}!
      </h1>
      <p className={styles.subtitle}>Это ваша главная панель управления</p>

      <div className={styles.cards}>
        <div className={styles.card}>
          <h3>Email</h3>
          <p>{user.email}</p>
        </div>
        <div className={styles.card}>
          <h3>Телефон</h3>
          <p>{user.phone}</p>
        </div>
        <div className={styles.card}>
          <h3>Организация</h3>
          <p>{user.org?.name || "-"}</p>
        </div>
      </div>

      <div className={styles.cards}>
        <div className={styles.card}>
          <h3>Количество зарегистрированных компаний</h3>
          <p>Активные: {activeCompanies}</p>
          <p>Неактивные: {inactiveCompanies}</p>
          <p>С интеграцией кассы: {withCashIntegration}</p>
          <p>Без интеграции кассы: {withoutCashIntegration}</p>
        </div>

        <div className={styles.card}>
          <h3>Общее количество продаж</h3>
          <p>{totalSales}</p>
        </div>

        <div className={styles.card}>
          <h3>Компании с интеграцией Kaspi</h3>
          <p>{kaspiIntegration}</p>
        </div>
      </div>

      <div className={styles.info}>
        <h2>Дополнительная информация</h2>
        <p>Роль: <b>{user.role_id}</b></p>
        <p>Статус: <b>{user.status}</b></p>
        <p>Дата создания: <b>{new Date(user.inserted_at).toLocaleDateString()}</b></p>
      </div>
    </div>
  );
}

export default Main;
